import { render, staticRenderFns } from "./Group-Permanent.vue?vue&type=template&id=63e28b03&"
import script from "./Group-Permanent.vue?vue&type=script&lang=js&"
export * from "./Group-Permanent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports